import c from 'classnames';
import { DEFAULT_INPUT_TYPOGRAPHY_VARIANT, INPUT_DISABLED_CLASSES, INPUT_APPEARANCE_CLASSES, INPUT_SHAPE_CLASSES, INPUT_SIZE_CLASSES, INPUT_ADORNMENT_SPACING_CONFIG } from './consts.js';
import { inputStyles } from './styles.js';
import { InputAdornmentEnum } from './types.js';

var getInputAdornmentEnum = function getInputAdornmentEnum(params) {
  var endAdornment = params.endAdornment,
    startAdornment = params.startAdornment;
  if (endAdornment && startAdornment) {
    return InputAdornmentEnum.Both;
  } else if (endAdornment) {
    return InputAdornmentEnum.End;
  } else if (startAdornment) {
    return InputAdornmentEnum.Start;
  } else {
    return InputAdornmentEnum.None;
  }
};
var getInputTypographyVariant = function getInputTypographyVariant(params) {
  var size = params.size,
    variant = params.variant;
  return variant || DEFAULT_INPUT_TYPOGRAPHY_VARIANT[size];
};
var getInputClasses = function getInputClasses(params) {
  var appearance = params.appearance,
    color = params.color,
    endAdornment = params.endAdornment,
    shape = params.shape,
    size = params.size,
    startAdornment = params.startAdornment,
    variant = params.variant;
  var appearanceClassname = INPUT_APPEARANCE_CLASSES[appearance];
  var shapeClassname = INPUT_SHAPE_CLASSES[shape];
  var sizeClassname = INPUT_SIZE_CLASSES[size];
  var spacingClasses = INPUT_ADORNMENT_SPACING_CONFIG[size][shape][getInputAdornmentEnum({
    endAdornment: endAdornment,
    startAdornment: startAdornment
  })];
  return {
    disabled: c(INPUT_DISABLED_CLASSES[appearance], 'pointer-events-none'),
    input: c('p-0 h-auto self-stretch placeholder-text-placeholder', color, variant, spacingClasses.input),
    inputAdornedEnd: 'me-4',
    inputAdornedStart: 'ms-8',
    inputMultiline: spacingClasses.inputMultiline,
    multiline: c('p-0', spacingClasses.multiline),
    notchedOutline: 'border-none',
    root: c('overflow-hidden', inputStyles, sizeClassname, shapeClassname, appearanceClassname, spacingClasses.root)
  };
};

export { getInputClasses, getInputTypographyVariant };
//# sourceMappingURL=utils.js.map
